import { makeStyles, Tooltip } from '@material-ui/core';
import { Error as ErrorIcon } from '@material-ui/icons';
import PropTypes from 'prop-types';
import React from 'react';

const useTooltipErrorStyles = makeStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.error.main,
    fontSize       : '12px',
    padding        : theme.spacing(1),
  },
  arrow: {
    color: theme.palette.error.main,
  },
}));

const TooltipError = ({ children, error, tooltipPlacement }) => {
  const classes = useTooltipErrorStyles();

  if (!error) {
    return children;
  }

  return (
    <Tooltip
      title={error}
      placement={tooltipPlacement}
      color="error"
      classes={{
        tooltip: classes.tooltip,
        arrow  : classes.arrow,
      }}
    >
      <ErrorIcon data-testid="icon.tooltip-error" />
    </Tooltip>
  );
};

TooltipError.propTypes = {
  children        : PropTypes.node,
  error           : PropTypes.string,
  tooltipPlacement: PropTypes.string,
};

TooltipError.defaultProps = {
  error           : null,
  children        : null,
  tooltipPlacement: 'top',
};

export default TooltipError;
